import type { IPlace } from "@bbj-types/address";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosStructurePartner } from "./axios";

export interface IGetStructurePartnerResponse {
  _id: ObjectId;
  name: string;
  website?: string;
  comment?: string;
  privileged: boolean;
  place?: IPlace;
  enableFup: boolean;
  tags: string[];
  contacts: string[];
  offers: string[];
  author: {
    firstName: string;
    lastName: string;
  };
  createdAt: Date;
  updatedAt: Date;
}

export const useGetStructurePartner = () => {
  const [state, execute, cancel] = axiosStructurePartner<IGetStructurePartnerResponse, unknown>(
    {
      url: "/{id}",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({ url: id });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
